import { Link } from 'gatsby-link'
import React, { PropsWithChildren } from 'react'
import { isNullOrWhiteSpace } from '../../utilities/string'

type TabletListItemProps = {
  heading: string
  link?: string
}

export const TabletListItem = ({
  children,
  heading,
  link,
}: PropsWithChildren<TabletListItemProps>) => (
  <li className="flex items-center py-10 font-t text-t-300 text-secondary-darker border-t border-neutral-light">
    <span className="font-medium w-90 tb:w-120">{heading}</span>

    <span className="flex-1 font-light">
      {!isNullOrWhiteSpace(link) ? (
        <Link className="text-primary font-medium" to={link}>
          {children}
        </Link>
      ) : (
        children
      )}
    </span>
  </li>
)
